import { Add, Close, Description, Edit } from "@mui/icons-material";
import { TableCell, useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { ActivateConsentDialog } from "./ActivateConsentDialog";
import { EditDependentModal } from "./form/EditDependentModal";
import {
  TableActionButton,
  TableActionGroup,
} from "../../../components/GenericTable/TableActionButton";

interface IProps {
  row: any;
  received: any;
}

function DependentListActionsBar({
  row,
  received,
  onEdit,
  onActivate,
  onInactivate,
  onOpenRecords,
  fullWidth = false,
  compact = false,
}: {
  row: any;
  received: any;
  onEdit: () => void;
  onActivate: () => void;
  onInactivate: () => void;
  onOpenRecords: () => void;
  fullWidth?: boolean;
  compact?: boolean;
}) {
  const auxConsentType = received?.find(
    (el: any) => el?.id === row?.identifier?.replace(/[^a-zA-Z0-9]/g, "")
  );

  return (
    <TableActionGroup fullWidth={fullWidth}>
      <TableActionButton
        compact={compact}
        icon={<Edit />}
        label="Editar"
        tone="primary"
        onClick={onEdit}
      />

      {row?.verify && !row?.end && auxConsentType ? (
        <TableActionButton
          compact={compact}
          icon={<Description />}
          label="Prontuário"
          tone="neutral"
          onClick={onOpenRecords}
        />
      ) : null}

      {row?.start ? (
        <TableActionButton
          compact={compact}
          icon={<Close />}
          label="Inativar"
          tone="error"
          onClick={onInactivate}
        />
      ) : (
        <TableActionButton
          compact={compact}
          icon={<Add />}
          label="Ativar"
          tone="success"
          onClick={onActivate}
        />
      )}
    </TableActionGroup>
  );
}

export function DependentListActions({ row, received }: IProps) {
  const theme = useTheme();
  const isMobileLayout = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();

  const [confirmDialog, setConfirmDialog] = useState<boolean>(false);
  const [type, setType] = useState("");
  const [editModalOpen, setEditModalOpen] = useState(false);

  const auxConsentType = received?.find(
    (el: any) => el?.id === row?.identifier?.replace(/[^a-zA-Z0-9]/g, "")
  );

  const actionBar = (
    <DependentListActionsBar
      row={row}
      received={received}
      fullWidth={isMobileLayout}
      compact={!isMobileLayout}
      onEdit={() => setEditModalOpen(true)}
      onActivate={() => {
        setConfirmDialog(true);
        setType("Add");
      }}
      onInactivate={() => {
        setConfirmDialog(true);
        setType("Remove");
      }}
      onOpenRecords={() => {
        navigate("/summary", {
          state: {
            patientId: row?.identifier?.replace(/[^a-zA-Z0-9]/g, ""),
            purpose: auxConsentType?.purpose,
          },
        });
      }}
    />
  );

  const dialogs = (
    <>
      {confirmDialog && type ? (
        <ActivateConsentDialog
          isOpen={confirmDialog}
          row={row}
          setType={setType}
          setIsOpen={setConfirmDialog}
          type={type}
        />
      ) : null}

      <EditDependentModal
        open={editModalOpen}
        onClose={() => setEditModalOpen(false)}
        patient={row?.fullResource}
      />
    </>
  );

  if (isMobileLayout) {
    return (
      <>
        {actionBar}
        {dialogs}
      </>
    );
  }

  return (
    <>
      <TableCell align="center" sx={{ verticalAlign: "middle" }}>
        {actionBar}
      </TableCell>
      {dialogs}
    </>
  );
}
